/** The upload endpoint's own limit, checked here so a large file is refused before it is sent. */
export const MAX_FONT_BYTES = 2 * 1024 * 1024

/** Why a file cannot be uploaded as a font, or null when it can. */
export function fontFileProblem(file: File): { title: string; message: string } | null {
    if (!file.name.toLowerCase().endsWith('.woff2')) return { title: 'Unsupported file', message: 'Please upload a .woff2 font file.' }
    if (file.size > MAX_FONT_BYTES) return { title: 'File too large', message: 'Font files must be 2 MB or smaller.' }
    return null
}

/**
 * The font file a picker just chose, cleared from the input so the same file can be chosen again, or
 * null when nothing usable was chosen (in which case the person has already been told why).
 */
export function takeFontFile(e: Event, showError: (title: string, message: string) => void): File | null {
    const input = e.target as HTMLInputElement
    const file = input.files?.[0]
    input.value = ''
    if (!file) return null
    const problem = fontFileProblem(file)
    if (problem) {
        showError(problem.title, problem.message)
        return null
    }
    return file
}
